/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, { useContext, useState, useEffect,useCallback} from 'react';
import GlobalContext from '../../../../components/Context/GloablContext';
import { useNavigate,useParams, useSearchParams } from 'react-router-dom';
import { CognitoData } from '../../../../CommonMethods/CognitoData';
import { dataService } from '../../../../services/data.services';
import CardHeader from '../../../../components/CardHeader';
import FeeStructureDropdown from '../../../../components/FeeStructureDropdown';
import WarningMessage from '../../../../components/WarningMessage';
import CustomOverLay from '../../../../components/CustomOverlay';
import Toast from '../../../../components/Toast';
import moment from "moment";
import Loader from '../../../../components/Loader';
import { GetBranchId } from '../../../../CommonMethods/GetBranchId';
import UpdateButton from '../../../../components/UpdateButton';

const AddFeeStructure = ({Type}) => {
    const location = useNavigate();
    const { fee_structure_id } = useParams();
    const {setToastmessage, isSideNavBar,UpdateCall, setUpdateCall, isInactiveBranch} =useContext(GlobalContext)
    const [feeHeadName, setFeeHeadName] = useState("");
    const [feeHeadError, setFeeHeadError] = useState("");
    const [loading, setLoading] = useState(false);
    const [editData, seteditData] = useState({});
    const [toastErrorMessage,setToastErrorMessage] = useState("")
    const [onBlurState,setOnBlurState] = useState(false)
    const [existingName,setExistingName]=useState([])
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams('')
    const [newClassFields, setNewClassFields] = useState([
        { fee_head: '', amount: '', optional_subject: {}, fee_head_id: '',},
    ]);
    const [feeStructureFields, setFeeStructureFields] = useState({
        academic_year: {},
        class_name: "",
        fees: newClassFields
    })
    const [warningMessage, setWarningMessage] = useState('')
    const [academicYear, setAcademicYear] = useState([])
    const [classes, setClasses] = useState([])
    const [feeHead, setFeeHead] = useState([])
    const [subjects, setSubjects] = useState([])
    const [emptyField, setEmptyField] = useState(false);
    const [selectedInput, setSelectedInput] = useState('');
    const [status,setStatus]=useState('')
    const Tittle = "fee heads"

    /* The above code is a JavaScript React code snippet. It defines a function called `handleFetch`
    using the `useCallback` hook. */
    const handleFetch = useCallback(async () => {
        try{
            let response = await dataService.GetAPI(`fee-structures/${fee_structure_id}`);
            if (response.data.status === 200) {
                const Getdata = response.data.data;
                seteditData(JSON.parse(JSON.stringify(Getdata)));

                setFeeStructureFields({
                    academic_year: Getdata?.academic_year,
                    class_name: Getdata?.class_name,
                    class_id: Getdata?.class_id,
                    fees:setNewClassFields(Getdata.fees)
                });
                setStatus(Getdata.status)
            }
        } catch (error){
            navigate('/404')
        }

    }, [fee_structure_id]);

    /* The above code is using the useEffect hook in a React component. It is setting up a side effect
    that will be triggered whenever the value of the "edit" variable changes. */
    useEffect(() => {
        if ((Type=='Edit' || Type=='View')) handleFetch();
    }, [handleFetch]);

    /**
     * The function `handleOnchangeInput` updates the state variables `feeStructureFields`,
     * `selectedInput`, `toastErrorMessage`, and `emptyField` based on the provided `id` and `option`
     * values.
     */
    const handleOnchangeInput = (id, option) => {
        setToastErrorMessage('')
        setEmptyField(false)
        setSelectedInput('');
        if(id === "academic_year") {
            setFeeStructureFields((prv) => ({
                ...prv,
                "academic_year": {
                    "name": option.name,
                    "start_date": option.start_date,
                    "end_date": option.end_date,
                    "academic_year_id": option._id
                }
            }));
        } else {
            setFeeStructureFields((prv) => ({
                ...prv,
                "class_name": option.name,
                "class_id": option._id
                
            }));
        }
    }

    /**
     * The function `handleClassFieldChange` is used to update the selected input field in a React
     * component and modify the state variables accordingly.
     */
    const handleClassFieldChange = (dropDownName, option, index) => {
        setSelectedInput(index);
        setToastErrorMessage('');
        setEmptyField(false);
        setExistingName([]);
    
        const updatedClassFields = [...newClassFields];
        if (dropDownName === 'fee_head') {
            updatedClassFields[index]["fee_head"] = option.name;
            updatedClassFields[index]["fee_head_id"] = option._id;
            onFeeheadBlur();
        }
        if (dropDownName === "amount") {
            // Remove any non-numeric and non-dot characters
            let inputValue = option.replace(/[^\d.]/g, '');
        
            // Limit to a maximum length of 5 characters (including decimal and decimals)
            if (inputValue?.length <= 13) {
                // Allow only up to 2 decimal places
                // eslint-disable-next-line security/detect-unsafe-regex
                const regex = /^(\d{1,10}(\.\d{0,2})?)?$/;
                if (regex.test(inputValue)) {
                    if (option?.length <= 15) {
                        updatedClassFields[index]["amount"] = inputValue;
                    }
                }
            }
            setSelectedInput(index);
        } else if (dropDownName === 'optional_subject') {
            updatedClassFields[index]["optional_subject"] = {
                "subject_name": option.name,
                "subject_id": option._id,
            };
            onOptionalSubjectBlur();
        } else {
            updatedClassFields[index][dropDownName] = option.name;
        }
        setNewClassFields(updatedClassFields);
    };
    

    /**
     * The `handleAddFeeStructure` function is responsible for adding a new fee structure or updating
     * an existing fee structure in a React application.
     * @returns The function `handleAddFeeStructure` does not explicitly return anything.
     */
    const handleAddFeeStructure = async () => {
        setLoading(true);
    
        const hasEmptyFields = () => {
            return newClassFields.some(field => field.amount === '' || isNaN(field.amount) || field.fee_head === '');
        };    
        const isMandatoryFieldEmpty = () => {
            return !feeStructureFields.academic_year || !feeStructureFields.academic_year.academic_year_id || !feeStructureFields.class_name;
        };
    
        const getUniqueSubjectNames = (subjectObject) => {
            return Object.values(subjectObject).map(subject => subject.trim().toLowerCase());
        };
    
        const existingFeeNames = [];
        const existingSubjectNames = [];
        const feeNamesCount = {};
        const subjectNamesCount = {};
    
        newClassFields.forEach(field => {
            const { fee_head, optional_subject } = field;
            const trimmedFeeHead = fee_head.trim().toLowerCase();
            feeNamesCount[trimmedFeeHead] = (feeNamesCount[trimmedFeeHead] || 0) + 1;
    
            if (optional_subject && typeof optional_subject === 'object') {
                const subjectNames = getUniqueSubjectNames(optional_subject);
                subjectNames.forEach(name => {
                    subjectNamesCount[name] = (subjectNamesCount[name] || 0) + 1;
                });
            }
        });
    
        existingFeeNames.push(...Object.keys(feeNamesCount).filter(name => feeNamesCount[name] > 1));
        existingSubjectNames.push(...Object.keys(subjectNamesCount).filter(name => subjectNamesCount[name] > 1));
    
        if (hasEmptyFields() || isMandatoryFieldEmpty()) {
            setLoading(false);
            setEmptyField(true);
            setWarningMessage("");
            setToastErrorMessage("Please fill in all the mandatory fields");
            return;
        } else if (existingFeeNames.length > 0) {
            setLoading(false);
            setWarningMessage("");
            setToastErrorMessage(`This Fee Head Name already exists. Try another`);
            return;
        } else if (existingSubjectNames.length > 0) {
            setLoading(false);
            setWarningMessage("");
            setToastErrorMessage(`Optional Subject name already exists. Try another`);
            return;
        }
    
        function isAmountZero() {
            return newClassFields.some(object => object.amount <= 0);
        }
    
        if (isAmountZero()) {
            setLoading(false);
            setToastErrorMessage("Amount must be greater than zero");
            return;
        }
    
        setLoading(true);
        try {
            let endpoint = '';
            const user = await CognitoData();
            let response = null;
    
            if ((Type=='Edit' || Type=='View')) {
                let body = {
                    academic_year: feeStructureFields.academic_year,
                    class_name: feeStructureFields.class_name,
                    class_id: feeStructureFields.class_id,
                    fees: newClassFields.map(field => ({
                        ...field,
                        amount: parseFloat(field.amount) // Convert amount to float
                    }))
                };
                response = await dataService.PatchAPI(body, `fee-structures/${fee_structure_id}`);
                setToastmessage("Fee structure updated successfully");
            } else {
                const branch_id = await GetBranchId();
                let body = {
                    academic_year: feeStructureFields.academic_year,
                    class_name: feeStructureFields.class_name,
                    class_id: feeStructureFields.class_id,
                    fees: newClassFields.map(field => ({
                        ...field,
                        amount: parseFloat(field.amount) // Convert amount to float
                    })),
                    branch_id: branch_id
                };
                response = await dataService.PostAPI(body, `fee-structures`);
                setToastmessage(response?.data.data?.message);
            }
            navigate(`/fee-management/fee-structure?${searchParams.toString()}`);
            setLoading(false)

        } catch (error) {
            setLoading(false);
            setExistingName(error?.response?.data?.existing_name);
            if (error?.response?.data?.message === "This fee head already exists. Try another") {
                setFeeHeadError("This Fee Head Name already exists. Try another");
            } else {
                setToastErrorMessage(error?.response?.data?.message || "Something went wrong");
            }
        }
    };

    /* The above code is using the useEffect hook in React to perform some actions when the component
    is mounted. It is calling four different functions: getAcademicyears(), getClasses(),
    getFeeheads(), and getSubjects(). These functions are likely responsible for fetching data from
    an API or performing some other asynchronous operation. The empty array [] passed as the second
    argument to useEffect ensures that these functions are only called once, when the component is
    initially mounted. */
    useEffect(() => {
        getAcademicyears();
        getClasses();
        getFeeheads();
        getSubjects();
    }, [])
    
    /**
     * The function `getAcademicyears` retrieves academic years from an API, transforms the data by
     * adding the start and end dates to the name, and sets the transformed data to the state variable
     * `AcademicYear`.
     */
    const getAcademicyears = async () => {
        const branch_id = await GetBranchId()
        let endpoint = `academic-years?filter=true&branch_id=${branch_id}&status=ongoing,upcoming&role=fee-structures`
        const response = await dataService.GetAPI(endpoint, true);
        const temp = (response.data?.data?.data);
        
        const transformedTemp= [];
        Object.keys(temp).forEach((key) => {
            transformedTemp[key] = {...temp[key],name:temp[key].name + '('+moment(temp[key].start_date).format("MMM DD, YYYY")+'-'+moment(temp[key].end_date).utcOffset('+00:00').format("MMM DD, YYYY")+')'}
            
        });
        setAcademicYear(temp);
    }

    /**
     * The function `getClasses` is an asynchronous function that retrieves classes data from an API
     * and sets it to the `Classes` state variable.
     */
    const getClasses = async () => {
        const branch_id = await GetBranchId()
        let endpoint = `classes?branch_id=${branch_id}&filter=true&status=true&role=fee-structures`
        const response = await dataService.GetAPI(endpoint, true);
        const temp = (response.data?.data?.data);
        setClasses(temp)
    }

    /**
     * The function `getFeeheads` is an asynchronous function that retrieves fee heads from an API and
     * sets the retrieved data to the state variable `FeeHead`.
     */
    const getFeeheads = async () => {
        const branch_id = await GetBranchId()
        let endpoint = `feehead?branch_id=${branch_id}&filter=true&status=true&role=fee-structures`
        const response = await dataService.GetAPI(endpoint, true);
        const temp = (response.data?.data?.data);
        setFeeHead(temp)
    }

    /**
     * The function `getSubjects` is an asynchronous function that retrieves subjects based on certain
     * filters and sets the retrieved subjects in the state.
     */
    const getSubjects = async () => {
        const branch_id = await GetBranchId()
        let endpoint = `subjects?branch_id=${branch_id}&filter=true&status=true&is_optional=true&role=fee-structures`
        const response = await dataService.GetAPI(endpoint, true);
        const temp = (response.data?.data?.data);
        setSubjects(temp)
    }

    /**
     * The function removes a class field from an array of class fields in React state.
     */
    const handleRemoveClassField = (indexToRemove) => {
        setEmptyField(false);
        setToastErrorMessage('')
        const updatedClassFields = newClassFields.filter((_, index) => index !== indexToRemove);
        setNewClassFields(updatedClassFields);
    };

    /**
     * The function `handleAddClassField` adds a new object to the `newClassFields` array and updates
     * the state variables `emptyField`, `toastErrorMessage`, and `warningMessage` accordingly.
     */
    const handleAddClassField = () => {
        setEmptyField(false);
        setToastErrorMessage('')
        const updatedClassFields = [
            ...newClassFields,
            { fee_head: '', amount: '', optional_subject: {}, fee_head_id: '',},
        ];
        setNewClassFields(updatedClassFields);
        if (newClassFields?.length === 19)  {
            setToastErrorMessage('')
            setWarningMessage(Tittle)
        }
    };  

    /**
     * The handleNavigation function is used to navigate to the '/fee-management/fee-structure' route.
     */
    const handleNavigation = () => {
        //navigate(`/fee-management/fee-structure?${searchParams.toString()}`)
        navigate(-1)
    };

    /**
     * The onBlur function is used in a JavaScript React component to handle the onBlur event of an
     * input field, and it performs some validation checks and updates the state accordingly.
     */
    const onBlur = (input) => {
        setOnBlurState(true)
        setSelectedInput("");
        setEmptyField(false);
        if (input <= 0) {
            setToastErrorMessage("Amount must be greater than zero");
        }
    };

    /**
    * The function checks if a fee head name already exists in an array and displays a warning message
    * if it does.
    * @returns The function does not explicitly return anything.
    */
    const onFeeheadBlur = () => {
        setSelectedInput(null);
        setEmptyField(false);
        let existing_name = [];
        const namesCount = newClassFields.reduce((count, obj) => {
            const { fee_head } = obj;
            const trimmedName = fee_head.trim().toLowerCase();
            count[trimmedName] = (count[trimmedName] || 0) + 1;
            return count;
        }, {});
        existing_name = Object.keys(namesCount).filter(name => namesCount[name] > 1);
        existing_name = existing_name.filter(name => name !== "").map(name => name.trim());
        setExistingName(existing_name);
        if (existing_name?.length > 0) {
            setWarningMessage("");
            setToastErrorMessage(`This Fee Head Name already exists. Try another`);
        }
    };
    
    const onOptionalSubjectBlur = () => {
        setSelectedInput(null);
        setEmptyField(false);
        let existing_subject_name = [];
        const subjectNamesCount = newClassFields.reduce((count, obj) => {
            const { optional_subject } = obj;
            const trimmedName = optional_subject?.subject_name?.trim().toLowerCase();
            if (trimmedName) {
                count[trimmedName] = (count[trimmedName] || 0) + 1;
            }
            return count;
        }, {});
        existing_subject_name = Object.keys(subjectNamesCount).filter(name => subjectNamesCount[name] > 1);
        existing_subject_name = existing_subject_name.filter(name => name !== "").map(name => name.trim());
        setExistingName(existing_subject_name);
        if (existing_subject_name?.length > 0) {
            setWarningMessage("");
            setToastErrorMessage(`This optional subject name already exists. Try another`);
        }
    };
    

    return (
        <CardHeader noPadding classkey={`${newClassFields?.length>9?"":"overflow-y-hidden"}`}>
            <div class="mainDataCntnrTop shadow-s13" style={{position: 'sticky',position: '-webkit-sticky',}}>
                <div className='flex items-center'>
                    {Type=='View' && <a href="javascript:void(0)" onClick={()=>location(`/fee-management/fee-structure?${searchParams.toString()}`)}>
                        <img loading="lazy" decoding="async" src="/images/back-btnBlue.svg" alt="icon" />
                    </a>}
                    <h5 className={`pageHeader adderror ${Type=='View'?'ml-2.5':''}`}>{Type=='View'?'Fee Structure Details':`${Type} Fee Structure`}</h5>
                </div>
                <div class="flex items-center">
                    {Type!='View' && 
                    <>
                        <button onClick={() => handleNavigation()} type="button" class="cancl-btn">
                            Cancel 
                        </button>
                        <UpdateButton
                            ButtonName={Type=='Edit'?"Update":"Add"}
                            loading={loading}
                            handleOnCLick={handleAddFeeStructure}
                            classKey="actn-btn onboardInstitution"
                        /> 
                    </>}
                    {Type=='View' && 
                    <>
                        <button className="view-actn-btn"
                            onClick={() => {
                                navigate(`/fee-management/fee-structure/update-fee-structure/${fee_structure_id}?${searchParams.toString()}`)
                            }}
                        >
                            Edit
                        </button>
                    </>}
                </div>
            </div> 
            {(Type=='Edit' || Type=='View') && Object.keys(editData)?.length === 0 && <CustomOverLay Active text="Loading..." classKey={`flex flex-col justify-center items-center sidebarOpenedOverlay`}/>}
            {!((Type=='Edit' || Type=='View') && Object.keys(editData)?.length === 0) && <div class="mainDataCntnrPageDiv scrollBlue_thick">
                <div class="display">
                    {/*define and change 2xl width here-Anitha*/}
                    <div class="xl:w-[70%] 2xl:w-[72%] mx-auto">
                        <div class="border border-[#D0D5DD] p-3 rounded">
                            <div class="flex -mx-10">
                                <div class="px-10 w-1/2">
                                    <div class="w-full">
                                        <div class="flex items-center">
                                            <label
                                                for="bname"
                                                class="text-f7 font-normal text-[#031624] min-w-[120px] inline-flex"
                                            >
                                                Academic Year
                                            </label>
                                            {Type !='View' && <FeeStructureDropdown
                                                dropDownName={"academic_year"}
                                                id = {"name"}
                                                test_id = {"year_name"}
                                                divClassName={"relative w-full"}
                                                value={feeStructureFields?.academic_year?.name === undefined ? undefined  : `${feeStructureFields?.academic_year?.name} (${moment(feeStructureFields?.academic_year?.start_date).utcOffset('+00:00').format('MMM DD, YYYY')}-${moment(feeStructureFields?.academic_year?.end_date).utcOffset('+00:00').format('MMM DD, YYYY')}) `}
                                                placeHolder={"Select Year"}
                                                showErrorBorder={emptyField &&
                                                    Object.keys(feeStructureFields?.academic_year)
                                                        ?.length === 0}
                                                options={academicYear}
                                                handleOnchangeInput={handleOnchangeInput}
                                                tooltip={true}
                                                buttonDisabled={(Type=='Edit')}
                                                applyBGForDisabled={true}
                                            />}
                                            {Type =='View' && <label class="font-semibold min-w-[100px] inline-flex">
                                                {feeStructureFields?.academic_year?.name}
                                            </label>}
                                        </div>
                                    </div>
                                </div>
                                <div class="px-10 w-1/2">
                                    <div class="w-full">
                                        <div class="flex items-center">
                                            <label
                                                for="bname"
                                                class="text-f7 font-normal text-[#031624] min-w-[100px] inline-flex"
                                            >
                                                Class Name
                                            </label>
                                            {Type!='View' && <FeeStructureDropdown
                                                dropDownName={"class_name"}
                                                value={feeStructureFields.class_name}
                                                divClassName={"relative w-full"}
                                                placeHolder={"Select Class Name"}
                                                showErrorBorder={emptyField && feeStructureFields?.class_name === ""}
                                                options={classes}
                                                handleOnchangeInput={handleOnchangeInput}
                                                buttonDisabled={Type=='Edit'}
                                                applyBGForDisabled={true}
                                            />}
                                            {Type =='View' && <label class="font-semibold min-w-[100px] inline-flex">
                                                {feeStructureFields.class_name}
                                            </label>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="xl:w-[70%] 2xl:w-[72%] mx-auto mt-10 border border-[#E6E8EA]">
                        <div class="flex w-full items-center p-3 pb-1.5 border-b border-[#E6E8EA] formHeaderbg">
                            <div class="flex items-center -mx-[30px] w-full">
                                <div class="w-1/3 pr-[15px] pl-[30px]">
                                    <div class="w-full">
                                        <p class="font-semibold text-f7 text-[#031624] class-name-error">
                                            Fee Head
                                        </p>
                                    </div>
                                </div>
                                <div class="w-1/3 px-[15px]">
                                    <div class="w-full">
                                        <p class="font-semibold text-f7 text-[#031624] class-name-error">
                                            Amount
                                        </p>
                                    </div>
                                </div>
                                <div class="w-1/3 px-[15px]">
                                    <div class="w-full">
                                        <p class="font-semibold text-f7 text-[#031624] class-name-error">
                                            Optional Subject
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="ml-2 min-w-[70px] max-w-auto flex items-center"></div>

                        </div>
                        {Type!='View' && newClassFields.map((field, index) => (
                            <div
                                key={index + "feeStructure"}
                                className="flex w-full items-center px-3 pb-3.5 pt-3 border-b border-[#E6E8EA]"
                            >
                                <div className="flex items-center -mx-[30px] w-full">
                                    <div className="w-1/3 pr-[15px] pl-[30px]">
                                        <FeeStructureDropdown
                                            id={`feeHead${index}`}
                                            isFeeStructure={true}
                                            dropDownName={"fee_head"}
                                            divClassName={"relative w-full"}
                                            placeHolder={"Select Fee Head"}
                                            showErrorBorder={((emptyField && newClassFields[index]?.fee_head.trim() === "")||(existingName?.includes(newClassFields[index]?.fee_head.trim().toLowerCase()) && selectedInput !== index))}
                                            options={feeHead}
                                            index={index}
                                            handleOnchangeInput={handleClassFieldChange}
                                            value={newClassFields[index].fee_head}
                                        />
                                    </div>
                                    <div className="w-1/3 px-[15px]">
                                        <div className="relative w-full">
                                            <label htmlFor="fname"></label>
                                            <input
                                                type="number"
                                                min={0}
                                                step={0.01}
                                                // maxLength="3"
                                                id={`amount`+index}
                                                class={`crncy-inpt-fld ${((emptyField && newClassFields[index].amount === "") ||
                                                    (emptyField && isNaN(newClassFields[index].amount)) ||
                                                    (onBlurState && newClassFields[index].amount <= 0 && newClassFields[index].amount !== "")) ? 'redBorder' : ''} w-full error_border`} 
                                                style={{'text-align':'left'}}
                                                onChange={(e) => {
                                                    setOnBlurState(false);
                                                    setSelectedInput(index);
                                                    handleClassFieldChange("amount", e.target.value, index);
                                                }}
                                                onWheel={e => e.target.blur()}
                                                value={newClassFields[index].amount}
                                                onBlur={() => onBlur(newClassFields[index].amount)}
                                                autoComplete="off"
                                            />
                                            <p
                                                alt="icon"
                                                className="absolute top-[50%] -translate-y-[50%] left-[13px] text-f7 text-normal text-[#818E98]"
                                            >
                                                {" "}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="w-1/3 pl-[15px] pr-[30px]">
                                        <FeeStructureDropdown
                                            id={`optional_subject${index}`}
                                            dropDownName={"optional_subject"}
                                            divClassName={"relative w-full"}
                                            placeHolder={"Select Subject"}
                                            isMandatoryField={true}
                                            showErrorBorder= {(emptyField && newClassFields[index]?.optional_subject?.subject_name === "") ||
                                            (existingName?.includes(newClassFields[index]?.optional_subject?.subject_name?.trim().toLowerCase()) && selectedInput !== index)}
                                            options={subjects}
                                            index={index}
                                            handleOnchangeInput={handleClassFieldChange}
                                            value={newClassFields[index]?.optional_subject?.subject_name === undefined ? "" : newClassFields[index].optional_subject.subject_name}
                                        />
                                    </div>
                                </div>
                                <div className="ml-2 min-w-[70px] max-w-auto flex items-center">
                                    {index === newClassFields?.length - 1 ? (
                                        <>
                                            {index !== 0 && (
                                                <div className='group relative'>
                                                    <img
                                                        src="/images/delete-bg-red-icon.svg"
                                                        alt="icon"
                                                        className="ml-2 cursor-pointer delete-icon"
                                                        onClick={() => handleRemoveClassField(index)}
                                                    />
                                                    <span className="absolute top-8 -left-[3px] scale-0 inline-flex flex-shrink-0 justify-center items-center gap-2.5 p-2.5 h-5 rounded-sm bg-[#d0d5dd] text-[#344054] text-xs font-medium leading-[12.5px] group-hover:scale-100">Delete</span>
                                                </div>
                                            )}
                                            {index !== 19 && (
                                                <div className='group relative'>
                                                    <img
                                                        src="/images/add-icon-blue.svg"
                                                        alt="icon"
                                                        id="plus_iconn"
                                                        className="ml-4 cursor-pointer add-icon"
                                                        onClick={handleAddClassField}
                                                    />
                                                    <span className="absolute top-8 left-[5px] scale-0 inline-flex flex-shrink-0 justify-center items-center gap-2.5 p-2.5 h-5 rounded-sm bg-[#d0d5dd] text-[#344054] text-xs font-medium leading-[12.5px] group-hover:scale-100">Add</span>
                                                </div>
                                            )}
                                        </>
                                    ) : (
                                        <div className='group relative'>
                                            <img
                                                src="/images/delete-bg-red-icon.svg"
                                                alt="icon"
                                                className="ml-2 cursor-pointer delete-icon"
                                                onClick={() => handleRemoveClassField(index)}
                                            />
                                            <span className="absolute top-8 -left-[3px] scale-0 inline-flex flex-shrink-0 justify-center items-center gap-2.5 p-2.5 h-5 rounded-sm bg-[#d0d5dd] text-[#344054] text-xs font-medium leading-[12.5px] group-hover:scale-100">Delete</span>
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))}

                        {Type=='View' && newClassFields.map((field, index) => (
                            <div
                                key={index + "feeStructure"}
                                className="flex w-full items-center px-3 pb-3.5 pt-3 border-b border-[#E6E8EA]"
                            >
                                <div className="flex items-center -mx-[30px] w-full">
                                    <div className="w-1/3 pr-[15px] pl-[30px]">
                                        {newClassFields[index].fee_head}
                                    </div>
                                    <div className="w-1/3 pr-[30px] pl-[20px]">
                                        {Number(newClassFields[index].amount).toFixed(2)}
                                    </div>
                                    <div className="w-1/3 pr-[30px] pl-[10px]">
                                        {newClassFields[index]?.optional_subject?.subject_name === undefined ? "--" : newClassFields[index].optional_subject.subject_name}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>}
            {toastErrorMessage !== '' && 
            <Toast 
                message={toastErrorMessage}
                type="error"
                setToastmessage={setToastErrorMessage}
            />   
            }       
            {warningMessage !== "" && 
                <WarningMessage
                    warningMessage={warningMessage}
                    setWarningMessage={setWarningMessage}
                />}
        </CardHeader>
      
    );
}

export default AddFeeStructure;
